















import {
  computed,
  defineComponent,
  ref,
  useFetch,
} from "@nuxtjs/composition-api";
import { usePageStore } from "~/stores/page";
import { useCategory } from "~/composables";
import { useTraverseCategory } from "~/modules/catalog/category/helpers/useTraverseCategory";
import { getMetaInfo } from "~/helpers/getMetaInfo";

const CategoryParent = () =>
  import("~/modules/catalog/category/components/CategoryParent.vue");
const CategoryChildren = () =>
  import("~/modules/catalog/category/components/CategoryChildren.vue");
const CategoryGameBrowser = () =>
  import("~/modules/catalog/category/components/CategoryGameBrowser.vue");
const CategoryLandingPage = () =>
  import("~/modules/catalog/category/components/CategoryLandingPage.vue");

import { useLayoutsStore } from "~/stores/extensionApi";
import { decodeUid } from "~/helpers";
import { magento } from "~/config/extensionsApi";

export default defineComponent({
  name: "CategoryPage",
  components: {
    CategoryParent,
    CategoryChildren,
    CategoryGameBrowser,
    CategoryLandingPage,
  },
  transition: "fade",
  setup() {
    const { routeData } = usePageStore();
    const { loadCategoryMeta } = useCategory();
    const { activeCategory } = useTraverseCategory();
    const layoutsStore = useLayoutsStore();
    const categoryMeta = ref(null);
    const displayMode = computed(() => {
      return activeCategory.value?.display_mode || "";
    });

    useFetch(async () => {
      try {
        categoryMeta.value = await loadCategoryMeta({
          category_uid: routeData.uid,
        });
      } catch (error) {
        categoryMeta.value = await loadCategoryMeta({
          category_uid: routeData.uid,
        });
      }

      if (categoryMeta.value) {
        categoryMeta.value.image = imageThum.value;
      }
    });

    const isParentCategory = computed(() => {
      return activeCategory.value && activeCategory.value.level === 2;
    });

    const getThumbnailImage = () => {
      if (isParentCategory.value) {
        const categoryId = decodeUid(routeData.uid);
        const layoutCategory = layoutsStore.getLayouts[categoryId];
        const thumb = layoutCategory?.filter(
          (e) => e.layout == "bannerImage"
        )[0]?.imageBanner[0]?.url;
        return thumb;
      } else return "";
    };

    const imageCategory = (url) => {
      return `${magento.media_url}${url?.replace("media", "")}`;
    };

    const imageThum = computed(() => {
      if (!activeCategory.value) return "";
      const image =
        activeCategory.value?.image ||
        activeCategory.value?.simi_category_thumbnail;
      return image ? imageCategory(image) : getThumbnailImage();
    });

    return {
      isParentCategory,
      displayMode,
      routeData,
      categoryMeta,
    };
  },
  head() {
    return getMetaInfo(this.categoryMeta);
  },
});
